import React, { FC } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'

import { IPlayer } from 'protos'
import TeamItem from 'components/Team/TeamItem'
import { JerseyPlaceholder } from 'components/Jersey'

type Props = {
  playerToSub?: IPlayer
  selectedPlayer?: IPlayer
  onPlayerClick: () => void
}

const useStyles = makeStyles(({ spacing }) => {
  return {
    placeholderContainer: {
      textAlign: 'center',
      padding: spacing(1, 0),
    },
  }
})

const SelectedPlayer: FC<Props> = ({ playerToSub, selectedPlayer, onPlayerClick }) => {
  const classes = useStyles()

  return (
    <Grid
      container
      alignItems="center"
    >
      {playerToSub ? (
        <TeamItem player={playerToSub} />
      ) : (
        <Grid
          item
          xs
          className={classes.placeholderContainer}
        >
          <JerseyPlaceholder />
        </Grid>
      )}

      <ArrowForwardIcon
        color="inherit"
        fontSize="large"
      />

      {selectedPlayer ? (
        <TeamItem
          showRemoveIcon
          player={selectedPlayer}
          onClick={onPlayerClick}
        />
      ) : (
        <Grid
          item
          xs
          className={classes.placeholderContainer}
        >
          <JerseyPlaceholder />
        </Grid>
      )}
    </Grid>
  )
}

export default SelectedPlayer
try {
    // @ts-ignore
    SelectedPlayer.displayName = "SelectedPlayer";
    // @ts-ignore
    SelectedPlayer.__docgenInfo = { "description": "", "displayName": "SelectedPlayer", "props": { "playerToSub": { "defaultValue": null, "description": "", "name": "playerToSub", "required": false, "type": { "name": "any" } }, "selectedPlayer": { "defaultValue": null, "description": "", "name": "selectedPlayer", "required": false, "type": { "name": "any" } }, "onPlayerClick": { "defaultValue": null, "description": "", "name": "onPlayerClick", "required": true, "type": { "name": "() => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/TeamEditor/components/SelectedPlayer.tsx#SelectedPlayer"] = { docgenInfo: SelectedPlayer.__docgenInfo, name: "SelectedPlayer", path: "src/components/TeamEditor/components/SelectedPlayer.tsx#SelectedPlayer" };
}
catch (__react_docgen_typescript_loader_error) { }